import React, { FunctionComponent, useState, useEffect, useCallback } from "react"
import { useLocation, useHistory } from "react-router"
import { Tabs, Tab } from "@material-ui/core"
import { isPublicPath, PUBLIC_PATHS } from "../common/hooks/useAuth"

interface RouteManifest {
    label: string
    route: string
}

const routeManifest: RouteManifest[] = [
    {
        label: "single",
        route: "/single"
    },
    {
        label: "batch",
        route: "/batch"
    },
    {
        label: "files",
        route: "/files"
    },
    {
        label: "transactions",
        route: "/transactions"
    },
    {
        label: "reports",
        route: "/reports"
    }
]

export const NavigationBar: FunctionComponent = props => {
    const loc = useLocation()
    const hist = useHistory()
    const [index, setIndex] = useState<number>(0)

    useEffect(() => {
        const index = routeManifest.findIndex(r => r.route === loc.pathname)
        setIndex(Math.max(index, 0))
    }, [loc]) // empty list to ensure effect only executes once

    const onTabClick = useCallback(
        (index, routeName) => {
            //set curPage & route
            setIndex(index)
            hist.replace(routeName)
        },
        [hist]
    )

    if (isPublicPath(loc.pathname)) {
        return null
    }

    return (
        <Tabs value={index} variant={"fullWidth"} id={"navbar"} data-testid={"nav_bar"}>
            {routeManifest.map((route, index) => {
                return (
                    <Tab
                        label={route.label}
                        id={`${route.label}PageOption`}
                        key={route.label}
                        onClick={() => onTabClick(index, route.route)}
                    ></Tab>
                )
            })}
        </Tabs>
    )
}
